import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-page-control',
  templateUrl: './page-control.component.html',
  styles: []
})
export class PageControlComponent implements OnInit {
  @Input()
  linkName: string;

  @Input()
  link: string;

  constructor(
    private router: Router
  ) { }

  ngOnInit() {

  }

  goBack() {
    this.router.navigateByUrl(this.link);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/page-control/page-control.component.ts